<template>
  <div id="pskform">

    <div class="card">
      <div class="print">
        <h1 style="color: #66CC00;">Overdrachtsformulier PSK</h1>
        <h4 style="margin-top: 20px">
          Dit formulier wordt gebruikt om uw bank-, verzekeraar of andere partij te vragen om uw
          opgebouwd kapitaal over te boeken naar Doelbeleggen. Print het formulier, vul waar nodig
          in en upload dit vervolgens weer op deze pagina. Dan sturen wij het
          voor u door.
        </h4>

        <h3 style="padding: 5px; background: grey; margin-top: 20px; color: white;">
          Uw huidige bank / verzekeraar
        </h3>
        <div style="padding-left: 10px; padding-right: 10px;">
          <table class="new">
            <tr>
              <th width="40%" style="vertical-align:top;">Naam bank / verzekeraar</th>
              <td>
                <b>{{currentPsk.instellingNaam === 'Anders'
                ? currentPsk.instellingNaamOmschrijving
                : currentPsk.instellingNaam}}</b>
              </td>
            </tr>
            <tr>
              <th>Naam rekening- polishouder</th>
              <td>
                <b>
                  {{intake.persoonsData[0].voorletters ? intake.persoonsData[0].voorletters : '-'}}
                  {{
                    intake.persoonsData[0].tussenvoegsel
                      ? intake.persoonsData[0].tussenvoegsel
                      : ''
                  }}
                  {{intake.persoonsData[0].achternaam ? intake.persoonsData[0].achternaam : '-'}}
                </b>
              </td>
            </tr>
            <tr>
              <th>Rekening- / polisnummer</th>
              <td>
                <b>{{currentPsk.overdrachtType === 'psk2'
                  ? currentPsk.iban
                  : currentPsk.polisnummer}}
                </b>
              </td>
            </tr>
            <tr>
              <th>E-mailadres bank / verzekeraar</th>
              <td>
                <br /><br />
                <p style="text-align: right; margin: 0px;">
                  <i class="grey" style="font-size: 12px">
                  alleen in te vullen indien bekend
                  </i>
                </p>
              </td>
            </tr>
          </table>

          <table class="new" style="margin-top: 15px;">
            <tr v-if="
              intake.goalData.type === 'gouden-handdruk-opbouwend'
              || intake.goalData.type === 'gouden-handdruk-uitkerend'"
            >
              <td>
                Het betreft een: gouden handdruk loonstamrecht <br/>
                <i class="grey" style="font-size: 10px">
                  als bedoeld in artikel 11 lid 1.g. van de Wet op de loonbelasting 1964
                  (tekst 2013)
                </i>
              </td>
            </tr>
            <tr v-else>
              <td>
                Het betreft een: pensioen lijfrente <br/>
                <i class="grey" style="font-size: 10px">
                  als bedoeld in artikel 3.125 lid 1 en artikel 3.126a lid 4 onderdeel a van de Wet
                  inkomstenbelasting 2001
                </i>
              </td>
            </tr>
          </table>
        </div>

        <h3 style="padding: 5px; background: grey; margin-top: 20px; color: white;">
          Onze gegevens
        </h3>
        <div style="padding-left: 10px; padding-right: 10px;">
          <table class="new" style="margin-bottom: 0px;">
            <tr>
              <th width="40%" style="vertical-align:top;">Naam, contactpersoon</th>
              <td width="40">
                <b>Doelbeleggen</b>
              </td>
              <td width="40">
                <b>T.a.v. J. Kalle</b>
              </td>
            </tr>
            <tr>
              <th width="40%" style="vertical-align:top;">E-mailadres, telnummer</th>
              <td>
                <b>info@vmvb.nl</b>
              </td>
              <td>
                <b>020-3449144</b>
              </td>
            </tr>
          </table>
          <table class="new">
            <tr>
              <th width="40%" style="vertical-align:top;">IBAN nummber</th>
              <td>
                <b>NL85ABNA0426198212</b>
              </td>
            </tr><tr>
              <th width="40%" style="vertical-align:top;">T.n.v.</th>
              <td>
                <b>Stichting Collectieve Beleggersgiro</b>
              </td>
            </tr><tr>
              <th width="40%" style="vertical-align:top;">Uw portefeuillenummer bij ons</th>
              <td>
                <b v-if="port"> {{port}} </b>
                <template v-else>
                <br />
                <p style="text-align: right; margin: 0px;">
                  <i class="grey" style="font-size: 12px">
                  wordt ingevuld door Doelbeleggen
                  </i>
                </p>
                </template>
              </td>
            </tr>
          </table>
        </div>

        <h3 style="padding: 5px; background: grey; margin-top: 20px; color: white;">
          Toestemming Doelbeleggen
        </h3>
        <div style="padding-left: 10px; padding-right: 10px;">
          <p>
            Na ondertekening geeft u Doelbeleggen en uw bank-, verzekeraar of andere partij
            toestemming om relevante informatie uit te wisselen ten behoeve van deze overdracht.
          </p>
        </div>

        <div class="msg" style="margin-top: 10px; margin-bottom: 5px;">
          <b>Let op, de velden hieronder dienen door u ingevuld te worden</b>
        </div>
        <h3 style="padding: 5px; background: #000066; margin-top: 10px; color: white;">
          <awesomeIcon icon="pencil-alt" /> Graag overdragen naar Doelbeleggen
        </h3>
        <div style="padding-left: 10px; padding-right: 10px;">
          <table class="new">
            <tr>
              <th width="10%">
                <div
                  style="
                    background-color: #ffffff;
                    border-radius: 2px;
                    border: 2px solid grey;
                    height: 15px; width: 15px;
                    margin-left: 4px;
                  "
                />
              </th>
              <td>
                <b>* de gehele overdrachtswaarde</b>
              </td>
              <th style="background-color: #f7f8fa;"></th>
            </tr>
            <tr>
              <th width="10%">
                <div
                  style="
                    background-color: #ffffff;
                    border-radius: 2px;
                    border: 2px solid grey;
                    height: 15px; width: 15px;
                    margin-left: 4px;
                  "
                />
              </th>
              <td>
                <b>* een overdrachtswaarde ter grootte van</b>
              </td>
              <th width="200">€</th>
            </tr>
          </table>
          <b>* graag aankruisen wat van toepassing is</b>
        </div>

        <h3 style="padding: 5px; background: #000066; margin-top: 20px; color: white;">
          <awesomeIcon icon="pencil-alt" /> Uw gegevens en akkoord
        </h3>
        <div style="padding-left: 10px; padding-right: 10px;">
          <table class="new">
            <tr>
              <th width="40%" style="vertical-align:top;">Uw naam</th>
              <td>
                <b>
                  {{intake.persoonsData[0].voorletters
                    ? intake.persoonsData[0].voorletters
                    : '-'
                  }}
                  {{
                    intake.persoonsData[0].tussenvoegsel
                      ? intake.persoonsData[0].tussenvoegsel
                      : ''
                  }}
                  {{intake.persoonsData[0].achternaam ? intake.persoonsData[0].achternaam : '-'}}
                </b>
              </td>
            </tr>
            <tr>
              <th width="40%" style="vertical-align:top;">Datum / plaats</th>
              <td style="text-align: center;">/</td>
            </tr>
            <tr>
              <th width="40%" style="vertical-align:top;">Handtekening</th>
              <td>
                <br/><br/><br/><br/>
              </td>
            </tr>
          </table>
        </div>

        <p style="margin-top: 25px; padding-left: 10px; padding-right: 10px;">
          Doelbeleggen is een initiatief en handelsnaam van Velthuyse • Mulder Vermogensbeheer B.V.
          en staat als beleggingsonderneming geregistreerd bij de AFM te Amsterdam.
        </p>
      </div>
      <div class="break" />
    </div>

  </div>
</template>

<script>

export default {
  components: {
  },
  props: {
    email: String,
    currentPsk: Object,
    intake: Object,
    port: String,
  },

};
</script>

<style lang="scss" scoped>
  @import "../../scss/_paper.scss";
</style>

<!-- modal print -->
<style lang="scss">
@media print {
  #status {
    display: none;
  }
  #mainview {
    padding: 0 !important;
  }
  .modal-background {
    position: relative !important;
    .modal {
      transform: unset !important;
      width: unset !important;
      position: relative !important;
      top: initial !important;
      left: initial !important;
      background-color: white;
      max-width: unset !important;
      .titlebar,
      .modalfooter {
        display: none;
      }
      .viewport {
        height: unset !important;
        width: unset !important;
        position: relative !important;
        padding: 0 !important;
        top: 0;
        overflow: hidden;
        > * {
          width: unset !important;
          height: unset !important;
        }
      }
    }
  }
}
</style>
